module.exports = __webpack_public_path__ + "img/imLogo.5bf204bf.png";